/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const CloudStateOnlineIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Cloud State Online',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    width="${width}"
    height="${height}"
    viewBox="0 0 20 20"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M9.25,17.00195H3.71777c-1.90332,0-3.45215-1.54785-3.45215-3.45117,0-1.49219.9668-2.78027,2.32422-3.25-.04297-.23145-.06445-.46582-.06445-.70312,0-2.17969,1.80957-3.95215,4.0332-3.95215.2793,0,.55762.0293.83105.08789.6377-1.95898,2.47656-3.34766,4.58887-3.34766,2.6709,0,4.84375,2.17285,4.84375,4.84473,0,.30762-.03125.61621-.09375.91895-.08203.40625-.47852.6709-.88477.58398-.40625-.08301-.66699-.47852-.58398-.88477.04102-.2041.0625-.41211.0625-.61816,0-1.84473-1.5-3.34473-3.34375-3.34473-1.66309,0-3.08008,1.25195-3.29688,2.91211-.03125.23535-.17188.44238-.37891.55762-.20801.11719-.45898.125-.6748.02832-.34863-.1582-.70898-.23828-1.06934-.23828-1.39648,0-2.5332,1.09961-2.5332,2.45215,0,.33203.06934.65625.20605.96484.09961.22363.08301.48242-.04395.69238s-.34863.34375-.59375.35938c-1.02539.06641-1.82812.91699-1.82812,1.93652,0,1.07617.87598,1.95117,1.95215,1.95117h5.53223c.41406,0,.75.33594.75.75s-.33594.75-.75.75Z"
      fill="currentColor"
    />
    <path
      d="M18.50293,13.43359c-.19238,0-.38379-.07324-.53027-.21973-.92773-.92871-2.16113-1.44043-3.47168-1.44141h-.00586c-1.30859,0-2.53711.50879-3.46191,1.43262-.29297.29297-.76758.29297-1.06055,0s-.29297-.76758,0-1.06055c1.20801-1.20801,2.81348-1.87207,4.52246-1.87207h.00684c1.71191.00195,3.32031.66992,4.53125,1.88086.29297.29297.29297.76758,0,1.06055-.14648.14648-.33887.21973-.53027.21973Z"
      fill="currentColor"
    />
    <path
      d="M16.38379,15.54395c-.19238,0-.38379-.07324-.53027-.21973-.74609-.74512-1.95898-.74902-2.70508-.00391-.29297.29297-.76758.29297-1.06055,0s-.29297-.76758,0-1.06055c.64355-.64355,1.49902-.99805,2.40918-.99805h.00391c.91113.00098,1.76855.35742,2.41309,1.00195.29297.29297.29297.76758,0,1.06055-.14648.14648-.33789.21973-.53027.21973Z"
      fill="currentColor"
    />
    <path
      id="b"
      data-name="Path 1027855"
      d="M15.13647,17.6399c-.35136.35136-.91882.35356-1.27096.00142s-.35277-.92244-.00142-1.27379.92165-.35072,1.27379.00142.34994.9196-.00142,1.27096Z"
      fill="currentColor"
    />
  </svg>`;
};
